module.exports = "<div class=screenshot> <div class=img-anchor></div> <p class=paste-tip>请使用Ctrl+V组合键粘贴</p> </div> <div class=btn-save-rechoose> <div class=cancel-to-rechoose>重新选择</div> <div class=comfirm-n-save>保存</div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/attachment-control/screenshot-receiver/screenshot-receiver.html
// module id = 2049
// module chunks = 50